// module factories are used so entry inlining is disabled
// startup
// Load entry module and return exports
__webpack_require__("./node_modules/@sentry/webpack-plugin/src/sentry-webpack.module.js");
var __webpack_exports__ = __webpack_require__("./src/csp-entry.ts");
